import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Textarea — Shadcn textarea primitive with WCAG 2.1 Phase 2 hardening.
 * Same `required` / `error` semantics as <Input>.
 */
const Textarea = React.forwardRef(({ className, required, error, "aria-invalid": ariaInvalid, ...props }, ref) => {
  const isInvalid = ariaInvalid !== undefined ? ariaInvalid : !!error;
  return (
    <textarea
      aria-required={required ? "true" : undefined}
      aria-invalid={isInvalid || undefined}
      required={required}
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        isInvalid && "border-red-500 focus-visible:ring-red-500",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
